import React from 'react';

import PropTypes from 'prop-types';

import Footer from 'wanderu-component-footer';
import {
    LongFormContent,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import tcConfig from '../../config/termsandconditions.locale';
import Header from '../Header/Header';

import styles from './TermsAndConditions.scss';

function TermsAndConditions(props) {
    const {
        t,
        intro,
        sections,
        shortcuts,
    } = props;

    return (
        <React.Fragment>
            <div className={styles.container}>
                <Header
                    subtitle={t('widgetSubtitle')}
                    title={t('widgetTitle')}
                />
                <LongFormContent
                    intro={intro}
                    namespace={tcConfig.namespace}
                    sections={sections}
                    shortcuts={shortcuts}
                />
            </div>
            <Footer />
        </React.Fragment>
    );
}

TermsAndConditions.propTypes = {
    intro: PropTypes.string,
    sections: PropTypes.arrayOf(PropTypes.object),
    shortcuts: PropTypes.arrayOf(PropTypes.object),
};
TermsAndConditions.defaultProps = {
    intro: '',
    sections: [],
    shortcuts: [],
};

export { TermsAndConditions };
export default localize(TermsAndConditions, tcConfig.namespace);
